module.exports = __webpack_public_path__ + "img/upkot.a5436ece.png";